import * as runtime from '@/api/runtime'
import {
  BatchLendCollectionListRequest,
  BatchLendCollectionListRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchLendCollectionListCondition,
  BatchLendCollectionListConditionFromJSON
} from '@/api/models/batch/BatchLendCollectionListCondition'

/**
 * 帳票作成
 */
export class BatchLendCollectionListApi extends runtime.BaseAPI {
  async return(request: BatchLendCollectionListRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/lend/lend-collection-list`,
      BatchLendCollectionListRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchLendCollectionListCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchLendCollectionListConditionFromJSON(jsonValue)
    ).value()
  }
}
